
const initialState = {
    route: 'home',
    settingFlag: false,
    loginPermissionFlag: false,
    activeContentTabIndex : 0,
    activeObj:null,
    popupFlag:null
};

export default initialState;
